<template>
  <div class="container" style="padding-bottom: 25px">
    <h3 class="title titile_des">一.安装前确认事项</h3>
    <div class="positionImg">
      <PreViewImage
        class="b1-1"
        :src="require('../../../assets/img/guide/b1-1.png')"
      />
    </div>
    <h3 class="title titile_des2">二.添加和配置打印机</h3>
    <p class="text">
      1、从福昕智慧打印官方网站下载客户端安装包；
    </p>
    <p class="text">
      官方地址：<a class="hrefA" href="https://www.foxitsoftware.cn/dayin"
        >https://www.foxitsoftware.cn/dayin</a
      >
    </p>
    <PreViewImage
      class="b1-2 commonImg mr50"
      :src="require('../../../assets/img/guide/b1-2.png')"
    />
    <p class="text">
      2、点击“一键安装”， 等待安装完成， 点击“立即使用 ”；
    </p>
    <PreViewImage
      class="b1-3 commonImg mr50 mrb70"
      :src="require('../../../assets/img/guide/b1-3.png')"
    />
    <h3 class="title">三.企业云办公账号注册</h3>
    <p class="text">
      1、企业用户可点击快速注册或前往云办公官网：
    </p>
    <p class="text">
      <a class="hrefA" href="https://www.foxitcloud.cn/register"
        >https://www.foxitcloud.cn/register</a
      >
      ，注册账号；
    </p>
    <div class="imgComtainer">
      <div style="margin-right: 23px">
        <PreViewImage
          class="b1-4 commonImg mr50 mrb70"
          :src="require('../../../assets/img/guide/b1-4.png')"
        />
      </div>
      <div>
        <PreViewImage
          class="b1-5 commonImg mr50 mrb70"
          :src="require('../../../assets/img/guide/b1-5.png')"
        />
      </div>
    </div>
    <p class="text">
      2、注册后，进入云办公官网：
    </p>
    <p class="text">
      <a class="hrefA" href="https://www.foxitcloud.cn/"
        >https://www.foxitcloud.cn/</a
      >
      ，管理中心；
    </p>
    <PreViewImage
      class="b1-6 commonImg mr50"
      :src="require('../../../assets/img/guide/b1-6.png')"
    />
    <p class="text">
      3、在管理中心，添加共享打印人员名单（需填写成员的手机号、邮箱），即可实现多人共享打印；
    </p>
    <PreViewImage
      class="b1-7 commonImg mr50"
      :src="require('../../../assets/img/guide/b1-7.png')"
    />
    <p class="text">
      4、子成员添加成功后，子成员的邮箱会收到账号、密码，使用这个账号密码（选择云办公账号登录）就可以手机扫码自助打印啦。
    </p>
    <PreViewImage
      class="b1-8 commonImg mr50"
      :src="require('../../../assets/img/guide/b1-8.png')"
    />
    <h3 class="title">四.打印配置说明</h3>
    <p class="text">
      1、登录，企业用户支持云办公账号登录方式，（个人用户支持微信、QQ扫码或福昕账号登录方式）；
    </p>
    <div class="imgComtainer">
      <div style="margin-right: 23px">
        <PreViewImage
          class="b1-9 commonImg mr50"
          :src="require('../../../assets/img/guide/b1-9.png')"
        />
      </div>
      <div>
        <PreViewImage
          class="b1-10 commonImg mr50"
          :src="require('../../../assets/img/guide/b1-10.png')"
        />
      </div>
    </div>
    <p class="text">
      2、自动查找可用打印机，点击“确认添加”；
    </p>
    <PreViewImage
      class="b1-11 commonImg mr50"
      :src="require('../../../assets/img/guide/b1-11.png')"
    />
    <p class="text">
      3、设置打印机参数，便于共享使用；
    </p>
    <PreViewImage
      class="b1-12 commonImg mr50"
      :src="require('../../../assets/img/guide/b1-12.png')"
    />
    <p class="text">
      4、如需修改打印设备配置，支持直接修改设备名称、使用范围、打印参数、快印码另存为|复制；
    </p>
    <p class="marks">备注：如需添加其他打印机，选择“再次添加设备”即可；</p>
    <PreViewImage
      class="b1-13 commonImg mr50"
      :src="require('../../../assets/img/guide/b1-13.png')"
    />
    <p class="text">
      5、默认开启共享模式，建议将该快印码打印黏贴或电子留存，便于分享至全员微信或QQ手机扫码使用；
    </p>
    <PreViewImage
      class="b1-14 commonImg mr50"
      :src="require('../../../assets/img/guide/b1-14.png')"
    />
    <PreViewImage
      class="b1-15 commonImg mr50"
      :src="require('../../../assets/img/guide/b1-15.png')"
    />
    <p class="text">
      6、如需设置具体使用人员，可点击使用范围，进行修改；
    </p>
    <PreViewImage
      class="b1-16 commonImg mr50"
      :src="require('../../../assets/img/guide/b1-16.png')"
    />
    <p class="text">
      7、若不考虑扫码打印，则点击关闭该快印码即可
    </p>
    <PreViewImage
      class="b1-17 commonImg mr50"
      :src="require('../../../assets/img/guide/b1-17.png')"
    />
    <PreViewImage
      class="b1-18 commonImg mr50"
      :src="require('../../../assets/img/guide/b1-18.png')"
    />
    <h3 class="title">五.联系我们</h3>
    <GuideBottom />
  </div>
</template>

<script>
import PreViewImage from "common/components/app/PreViewImage.vue";
import GuideBottom from "common/components/app/GuideBottom.vue";

export default {
  components: {
    PreViewImage,
    GuideBottom
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/guide.scss";

.titile_des {
  line-height: 48px;
  margin-top: 66px;
  height: auto;
}

.titile_des2 {
  line-height: 48px;
  margin-top: 0px;
  height: auto;
  margin-bottom: 50px;
}

.positionImg {
  position: relative;
  width: 100%;
  height: 422px;
}

.b1-1 {
  position: relative;
  width: 750px;
  margin-left: -40px;
  left: 0;
  top: 0;
}

.b1-2 {
  width: 553px;
}

.b1-3 {
  width: 514px;
}

.imgComtainer {
  padding-left: 40px;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
  img {
    width: 260px;
  }
}

.b1-4 {
  width: 262px;
}

.b1-5 {
  width: 259px;
}

.b1-6 {
  width: 556px;
}

.b1-7 {
  width: 554px;
}

.b1-8 {
  width: 399px;
}

.b1-9 {
  width: 262px;
}

.b1-10 {
  width: 259px;
}

.b1-11 {
  width: 544px;
}

.b1-12 {
  width: 460px;
}

.b1-13 {
  width: 623px;
}

.b1-14 {
  width: 623px;
}

.b1-15 {
  width: 315px;
}

.b1-16 {
  width: 623px;
}

.b1-17 {
  width: 546px;
}

.b1-18 {
  width: 546px;
}
</style>
